import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

const ContentHistoryStore = createStore({
	initialState: {
		wasTransitionedFromEditor: false,
	},
	actions: {
		setWasTransitionedFromEditor:
			(wasTransitionedFromEditor: boolean) =>
			({ setState }) => {
				setState({
					wasTransitionedFromEditor,
				});
			},
	},
	name: 'newContentHistoryState',
});

export const useNewContentHistoryState = createStateHook(ContentHistoryStore);
export const useNewContentHistoryActions = createActionsHook(ContentHistoryStore);
